import { render, staticRenderFns } from "./BpDataTableField.vue?vue&type=template&id=d2c73f6e&scoped=true&"
import script from "./BpDataTableField.vue?vue&type=script&lang=js&"
export * from "./BpDataTableField.vue?vue&type=script&lang=js&"
import style0 from "./BpDataTableField.vue?vue&type=style&index=0&id=d2c73f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c73f6e",
  null
  
)

export default component.exports